import { currentSubConfig, dictSubscriptionsMap } from '@/common/page_comp/News/SubTab/common/config.js';
import { change } from '@/restapi/favorite.js';
import { newToast } from '@dsee/components/popups/toast.js';
import Vue from 'vue';


export async function favoriteSub(id, object) {
    await change({
        id,
        favorite: true,
    });
    Vue.set(object, 'favorite', true);

    const { active, period } = currentSubConfig();

    if (active) {
        newToast({
            title: 'Продукт добавлен в избранное',
            text: `Вы подписались на обновления. Новости будут приходить ${ (dictSubscriptionsMap[period].name).toLowerCase() }`,
        });
    } else {
        newToast({
            title: 'Продукт добавлен в избранное',
            text: 'Вы подписались на обновления. Период рассылки можно выбрать в профиле пользователя',
        });
    }

    // метрика
    try {
        this.$metrika.reachGoal('add');
    } catch (e) {
        console.error('Не удалось отправить метрику: ' + e);
    }
}

export async function favoriteUnsub(id, object) {
    await change({
        id,
        favorite: false,
    });
    Vue.set(object, 'favorite', false);

    newToast({
        title: 'Продукт удален из избранного',
        text: 'Вы отписались от обновлений',
    });
}
